import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useParams } from "react-router-dom";
import Services from "../../api/Services";
import ServiceSidebar from "./sidebar";
import LocalizedLink from "../../components/LocalizedLink/LocalizedLink";
import ErrorPage from "../ErrorPage/ErrorPage";
import Footer from "../../components/footer/Footer";
import { Image } from "@imagekit/react";

const ServiceSinglePage = (props) => {
  const { slug } = useParams();
  const { t } = useTranslation("services");

  const serviceDetails = Services.find((item) => item.slug === slug);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  if (!serviceDetails) return <ErrorPage />;

  const bigDescription = t(`${slug}.bigDescription`, { returnObjects: true });

  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t(`${slug}.title`)} pagesub={t("listTitle")} />
      <section className="wpo-service-single-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="wpo-service-single-wrap">
                <div className="wpo-service-single-content">
                  <Image
                    src={serviceDetails.sSImg}
                    alt={t(`${slug}.title`)}
                    transformation={[
                      {
                        width: "897",
                        height: "521",
                        crop: "maintain_ratio",
                        focus: "auto",
                      },
                    ]}
                  />
                  <div className="wpo-service-single-content-des">
                    <h2 className="">{t(`${slug}.title`)}</h2>
                    <ProgramDetails bigDescription={bigDescription} />
                    {/* <p className="">{serviceDetails.bigDescription}</p> */}
                    {/* <div className="wpo-service-single-sub-img">
                                            <ul>
                                                <li><img src={simg1} alt="eimg" /></li>
                                                <li><img src={simg2} alt="eimg" /></li>
                                            </ul>

                                        </div> */}
                  </div>
                </div>
                <div className="wpo-solutions-section">
                  <h2 className="">{t("listTitle")}</h2>
                  <div className="row">
                    {Services.slice(0, 3).map((service, srv) => {
                      return (
                        <div className="col-lg-4 col-md-6 col-12" key={srv}>
                          <div className="wpo-solutions-item">
                            <div className="wpo-solutions-icon">
                              <div className="icon">
                                <span>{service.Id}</span>
                              </div>
                            </div>
                            <div className="wpo-solutions-text">
                              <h2>
                                <LocalizedLink
                                  onClick={ClickHandler}
                                  to={`/service-single/${service.slug}`}
                                >
                                  {t(`${service.slug}.title`)}
                                </LocalizedLink>
                              </h2>
                              <p>{t(`${service.slug}.shortDescription`)} </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {/* <div className="wpo-service-single-item">
                                    <div className="wpo-service-contact-area">
                                        <div className="wpo-contact-title">
                                            <h2>Have project in mind? Let's discuss</h2>
                                            <p>Get in touch with us to see how we can help you with your project</p>
                                        </div>
                                        <div className="wpo-contact-form-area">
                                            <Contact />
                                        </div>
                                    </div>
                                </div> */}
              </div>
            </div>
            <ServiceSidebar />
          </div>
        </div>
      </section>
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default ServiceSinglePage;

function ProgramDetails({ bigDescription }) {
  if (!bigDescription || typeof bigDescription !== "object") return null;

  const intro = bigDescription.intro || [];
  const sections = bigDescription.sections || [];

  return (
    <>
      {/* Intro paragraphs */}
      {intro.length > 0 && (
        <section>
          {intro.map((p, idx) => (
            <p className={idx !== intro.length - 1 ? "mb-0" : ""} key={idx}>
              {p}
            </p>
          ))}
        </section>
      )}
      {/* Sections */}
      <div className="row g-3">
        {sections.map((sec, idx) => (
          <div className="col-12" key={idx}>
            <div className="card shadow-sm h-100">
              <div className="card-body ">
                {sec.title ? (
                  <h5 className="card-title fw-semibold mb-3">{sec.title}</h5>
                ) : null}

                {/* Paragraphs */}
                {Array.isArray(sec.body) &&
                  sec.body.map((p, i) => (
                    <p
                      key={i}
                      className={i !== sec.body.length - 1 ? "mb-0" : ""}
                    >
                      {p}
                    </p>
                  ))}

                {/* Bullets */}
                {Array.isArray(sec.list) && sec.list.length > 0 && (
                  <ul className="list-group list-group-flush mt-3">
                    {sec.list.map((item, i) => (
                      <li key={i} className="list-group-item ">
                        {item}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Note */}
                {sec.note && (
                  <div className="alert alert-light border mt-3 mb-0 ">
                    {sec.note}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Content sections */}
    </>
  );
}
